import createIcon from '../../createIcon';

/**
 * @component @name AccessibleForward
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNSA2LjI3QzE4LjYwNDYgNi4yNyAxOS41IDUuMzc0NTcgMTkuNSA0LjI3QzE5LjUgMy4xNjU0MyAxOC42MDQ2IDIuMjcgMTcuNSAyLjI3QzE2LjM5NTQgMi4yNyAxNS41IDMuMTY1NDMgMTUuNSA0LjI3QzE1LjUgNS4zNzQ1NyAxNi4zOTU0IDYuMjcgMTcuNSA2LjI3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0LjUgMTYuNzNIMTIuNUMxMi41IDE4LjM4IDExLjE1IDE5LjczIDkuNSAxOS43M0M3Ljg1IDE5LjczIDYuNSAxOC4zOCA2LjUgMTYuNzNDNi41IDE1LjA4IDcuODUgMTMuNzMgOS41IDEzLjczVjExLjczQzYuNzQgMTEuNzMgNC41IDEzLjk3IDQuNSAxNi43M0M0LjUgMTkuNDkgNi43NCAyMS43MyA5LjUgMjEuNzNDMTIuMjYgMjEuNzMgMTQuNSAxOS40OSAxNC41IDE2LjczWk0xNy41IDEzLjIzSDE1LjY0TDE3LjMxIDkuNTZDMTcuOTIgOC4yMyAxNi45NCA2LjczIDE1LjQ2IDYuNzNIMTAuMjZDOS40NSA2LjczIDguNzIgNy4yIDguMzkgNy45M0w3LjcyIDkuNzNMOS42NCAxMC4yNkwxMC4yOSA4LjczSDEyLjVMMTAuNjcgMTIuODNDMTAuMDcgMTQuMTYgMTEuMDYgMTUuNzMgMTIuNTIgMTUuNzNIMTcuNVYyMC43M0gxOS41VjE1LjIzQzE5LjUgMTQuMTMgMTguNiAxMy4yMyAxNy41IDEzLjIzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AccessibleForward = createIcon('AccessibleForward', [
  [
    'path',
    {
      d: 'M17.5 6.27C18.6046 6.27 19.5 5.37457 19.5 4.27C19.5 3.16543 18.6046 2.27 17.5 2.27C16.3954 2.27 15.5 3.16543 15.5 4.27C15.5 5.37457 16.3954 6.27 17.5 6.27Z',
      key: 'hol8b',
    },
  ],
  [
    'path',
    {
      d: 'M14.5 16.73H12.5C12.5 18.38 11.15 19.73 9.5 19.73C7.85 19.73 6.5 18.38 6.5 16.73C6.5 15.08 7.85 13.73 9.5 13.73V11.73C6.74 11.73 4.5 13.97 4.5 16.73C4.5 19.49 6.74 21.73 9.5 21.73C12.26 21.73 14.5 19.49 14.5 16.73ZM17.5 13.23H15.64L17.31 9.56C17.92 8.23 16.94 6.73 15.46 6.73H10.26C9.45 6.73 8.72 7.2 8.39 7.93L7.72 9.73L9.64 10.26L10.29 8.73H12.5L10.67 12.83C10.07 14.16 11.06 15.73 12.52 15.73H17.5V20.73H19.5V15.23C19.5 14.13 18.6 13.23 17.5 13.23Z',
      key: 'unyvxm',
    },
  ],
]);

export default AccessibleForward;
